export const PAGE_PATH = '/fortuna-spin-wheel';
